import { Text } from "@mantine/core";
import { IconSparkles } from "@tabler/icons-react";
import "./EmailLoading.scss";

const EmailLoading = ({ gradientId = "blueCyanGradient" }) => {
  return (
    <div className="email-loading">
      <svg width="0" height="0">
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0077cc" stopOpacity="1" />
            <stop offset="100%" stopColor="#80C3FF" stopOpacity="1" />
          </linearGradient>
        </defs>
      </svg>
      <div className="animated-icon">
        <IconSparkles size={40} />
      </div>
      <Text size="xl" fw={500} className="loading-text">
        Generating Email
      </Text>
    </div>
  );
};

export default EmailLoading;
